// src/components/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const navItems = [
  { to: '/',           label: '📊 Dashboard',  exact: true },
  { to: '/viajes',     label: '🚌 Viajes' },
  { to: '/personal',   label: '👷 Personal' },
  { to: '/provincias', label: '📍 Provincias', adminOnly: true },
  { to: '/usuarios',   label: '👤 Usuarios',   adminOnly: true },
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  const styles = {
    wrapper: { display: 'flex', minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif', background: '#f0f2f5' },
    sidebar: {
      width: collapsed ? 60 : 220, transition: 'width .2s', background: '#1a1a2e',
      color: '#fff', display: 'flex', flexDirection: 'column', flexShrink: 0,
      transform: (window.innerWidth <= 768 && !collapsed) ? 'translateX(0)' : (window.innerWidth <= 768 && collapsed ? 'translateX(-100%)' : 'none'),
    },
    logo: { padding: '16px 12px', borderBottom: '1px solid #333', fontSize: 13, fontWeight: 700, letterSpacing: 1 },
    nav: { flex: 1, paddingTop: 12 },
    link: (active) => ({
      display: 'flex', alignItems: 'center', gap: 10, padding: '10px 16px',
      textDecoration: 'none', color: active ? '#f0c040' : '#ccc',
      background: active ? 'rgba(240,192,64,.15)' : 'transparent',
      borderLeft: active ? '3px solid #f0c040' : '3px solid transparent',
      fontSize: 13, transition: 'all .15s',
    }),
    main: { flex: 1, overflow: 'auto' },
    header: {
      background: '#fff', borderBottom: '1px solid #e8e8e8', padding: '12px 24px',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10
    },
    content: { padding: 24 },
    btn: {
      background: 'none', border: '1px solid #ccc', borderRadius: 6, padding: '6px 14px',
      cursor: 'pointer', fontSize: 12, color: '#555',
    },
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={styles.wrapper}>
      {window.innerWidth <= 768 && !collapsed && (
        <div className="sidebar-overlay" onClick={() => setCollapsed(true)}></div>
      )}
      <aside style={styles.sidebar} className={window.innerWidth <= 768 ? 'sidebar-mobile' : ''}>
        <div style={styles.logo}>
          {!collapsed && <span>⛏ MACDESA<br /><small style={{fontWeight:400,color:'#aaa'}}>Gestión de Viajes</small></span>}
          {window.innerWidth > 768 && (
            <button onClick={() => setCollapsed(!collapsed)} style={{...styles.btn,color:'#aaa',border:'none',marginTop:8}}>
              {collapsed ? '→' : '←'}
            </button>
          )}
          {window.innerWidth <= 768 && (
             <button onClick={() => setCollapsed(true)} style={{...styles.btn,color:'#aaa',border:'none', float:'right'}}>
               ✕
             </button>
          )}
        </div>
        <nav style={styles.nav}>
          {navItems.map(item => {
            if (item.adminOnly && !isAdmin) return null;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                style={({ isActive }) => styles.link(isActive)}
              >
                <span>{item.label.split(' ')[0]}</span>
                {!collapsed && <span>{item.label.split(' ').slice(1).join(' ')}</span>}
              </NavLink>
            );
          })}
        </nav>
        <div style={{ padding: 12, fontSize: 11, color: '#666', borderTop: '1px solid #333' }}>
          {!collapsed && <div>v1.0.0 MVP</div>}
        </div>
      </aside>

      <div style={styles.main}>
        <header style={styles.header}>
          <div style={{ fontWeight: 600, color: '#1a1a2e', display: 'flex', alignItems: 'center', gap: 10 }}>
            {window.innerWidth <= 768 && (
              <button onClick={() => setCollapsed(false)} style={{...styles.btn, padding: '4px 8px', fontSize: 16}}>
                ☰
              </button>
            )}
            MACDESA – Sistema de Viajes
          </div>
          <div style={{ display: 'flex', gap: 12, alignItems: 'center', fontSize: 13, flexWrap: 'wrap' }}>
            <span>👤 {user?.nombre}</span>
            <span style={{
              background: user?.rol === 'admin' ? '#e6f7ff' : '#f6ffed',
              color: user?.rol === 'admin' ? '#0050b3' : '#135200',
              padding: '2px 8px', borderRadius: 10, fontSize: 11,
            }}>{user?.rol}</span>
            <button style={styles.btn} onClick={handleLogout}>Salir</button>
          </div>
        </header>
        <main style={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}